import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: modules,
  plugins: [createPersistedState({
    key: 'vuex',
    reducer (value) {
      return (!value.user.token)
        ? {}
        : value
    }
  })]
})
